import { useState, useEffect } from "react";

import { Grid, InputLabel, IconButton } from "@pankod/refine-mui";
import { DeleteForever } from "@mui/icons-material";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./gallery-custom.css";
import UploadZone from "components/UploadZone";

import { API_URL } from "constants";
import axios from "utils/axios";
import { toast } from "react-toastify";

const GalleryManager = ({
  control,
  errors,
  setError,
  getValues,
  setValue,
  watch,
  defaultValue,
  fieldName,
}) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    // console.log(getValues(fieldName));
    if (defaultValue) {
      setImages(defaultValue);
    }
    const images = watch(fieldName);
    if (images) {
      setImages(images);
    }
  }, [defaultValue, fieldName, watch]);

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        height: "450px",
        maxHeight: "450px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          flex: "1 1 auto",
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <ImageGallery
          items={(images || []).map((image) => ({
            id: image.id,
            original: API_URL + image.url,
            thumbnail: API_URL + image.url,
            createdAt: image.createdAt,
          }))}
          renderItem={(item) => (
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                textAlign: "center",
              }}
            >
              <InputLabel sx={{ mt: 0, fontSize: 18 }}>
                {new Date(item.createdAt).toLocaleDateString()}
              </InputLabel>
              <IconButton
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 0,
                  color: "red",
                  width: 40,
                  height: 40,
                  zIndex: 1,
                }}
                onClick={async () => {
                  if (
                    window.confirm("Sei sicuro di voler rimuovere l'immagine?")
                  ) {
                    await axios.delete(`/api/upload/files/${item.id}`);
                    setImages(images.filter((image) => image.id !== item.id));
                    toast.success("Immagine rimossa con successo");
                  }
                }}
              >
                <DeleteForever sx={{ fontSize: 28 }} />
              </IconButton>
              <img
                src={item.original}
                alt={item.originalAlt}
                style={{
                  maxWidth: "100%",
                  maxHeight: "280px",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>
          )}
          showPlayButton={false}
          showFullscreenButton={false}
        />
      </div>
      <div style={{ width: "100%", flex: "0 0 auto", marginTop: "8px" }}>
        <UploadZone
          isButton
          label="Carica Immagine"
          errors={errors}
          setError={setError}
          setValue={setValue}
          onChange={(newImage) => {
            setValue(fieldName, [...(getValues(fieldName) || []), newImage], {
              shouldValidate: true,
            });
          }}
          required
        />
      </div>
    </div>
  );
};

export default GalleryManager;
